// extracted by mini-css-extract-plugin
export default {"vazio":"Vazio_vazio__1G-kG","pictograma":"Vazio_pictograma__cNmSc","titulo":"Vazio_titulo__Lhofc","texto":"Vazio_texto__JM3FF","acao":"Vazio_acao__PyVsk"};